import React from 'react'
import { IRoute } from '@interfaces/route.interface'
import { routersPath } from './routes-path'
import { EUserRoles } from '@enums/roles'

const DomainsPage = React.lazy(() => import('@pages/DomainsPage/DomainsPage'))
const CountriesPage = React.lazy(() => import('@pages/CountriesPage/CountriesPage'))
const BillingPage = React.lazy(() => import('@pages/BillingPage/BillingPage'))
const SearchPage = React.lazy(() => import('@pages/Search/SearchPage/SearchPage'))
const UserSearchPage = React.lazy(() => import('@pages/Search/UserSearchPage/UserSearchPage'))
const TariffsPage = React.lazy(() => import('@pages/TariffsPage/TariffsPage'))
const ReportsPage = React.lazy(() => import('@pages/Reports/ReportsPage/ReportsPage'))
const ExpensesPage = React.lazy(() => import('@pages/Reports/ExpensesPage/ExpensesPage'))
const IncomesPage = React.lazy(() => import('@pages/Reports/IncomesPage/IncomesPage'))
const SalaryPage = React.lazy(() => import('@pages/Reports/SalaryPage/SalaryPage'))
const ReportPage = React.lazy(() => import('@pages/ReportPage/ReportPage'))
const UsersPage = React.lazy(() => import('@pages/UsersPage/UsersPage'))
const CrmsPage = React.lazy(() => import('@pages/CrmsPage/CrmsPage'))
const AutomationPage = React.lazy(() => import('@pages/AutomationPage/AutomationPage'))
const UserPage = React.lazy(() => import('@pages/UserPage/UserPage'))
const MainPage = React.lazy(() => import('@pages/MainPage/MainPage'))
const CabinetsPage = React.lazy(() => import('@pages/CabinetsPage/CabinetsPage'))
const CabinetInfoPage = React.lazy(() => import('@pages/CabinetInfoPage/CabinetInfoPage'))

export const privateRoutes: IRoute[] = [
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.MAIN_PAGE,
    component: <MainPage />,
    title: 'Статистика',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.USERS,
    component: <UsersPage />,
    title: 'Пользователи',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CRMS,
    component: <CrmsPage />,
    title: 'Crms',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.AUTOMATION,
    component: <AutomationPage />,
    title: 'Автоматизация',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.USER,
    component: <UserPage />,
    title: 'User',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.REPORTS,
    component: <ReportsPage />,
    title: 'Reports',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.REPORT,
    component: <ReportPage />,
    title: 'Report',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.EXPENSES,
    component: <ExpensesPage />,
    title: 'Expenses',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.INCOMES,
    component: <IncomesPage />,
    title: 'Incomes',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.ACCOUNTANT, EUserRoles.SUPER_ADMIN],
    path: routersPath.SALARY,
    component: <SalaryPage />,
    title: 'Salary',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.BILLING,
    component: <BillingPage />,
    title: 'Billing',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN, EUserRoles.BOSS],
    path: routersPath.SEARCH,
    component: <SearchPage />,
    title: 'Search',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN, EUserRoles.BOSS],
    path: routersPath.SEARCH_USER,
    component: <UserSearchPage />,
    title: 'User Search',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.TARIFFS,
    component: <TariffsPage />,
    title: 'Telephony tariffs',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.COUNTRIES,
    component: <CountriesPage />,
    title: 'Countries',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.PERSONAS_ACCOUNT_DOMAINS,
    component: <DomainsPage />,
    title: 'Domains',
  },
  {
    roles: [EUserRoles.BOSS, EUserRoles.SUPER_ADMIN],
    path: routersPath.USER_PERSONAL_ACCOUNTS,
    component: <CabinetsPage />,
    title: 'Домены личных кабинетов',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CABINET_INFO,
    component: <CabinetInfoPage />,
    title: 'Информация о клиенте'
  }
]
